import { createActions } from 'redux-actions';

import { getIsLoggedInSelector } from '../reducers/AuthenticationReducer/AuthenticationSelector';
import { BaseFlashMessageOptionsStore } from '../reducers/FlashMessageReducer/FlashMessageReducer.types';
import { AppThunk } from '../shared/services/store';

interface IntlMessagesError {
  msg: string;
  defaultMessage: string;
  intlValues?: Object;
}

export const {
  removeFlashMessage,
  removeBlinkFlashMessage,
  removeFlashMessagesContexts,
  removeFlashMessagesContextsErrors,
  removeFlashLocations,
  removeFlashContexts,
  removeActiveContexts,
  addActiveContexts,
  replaceActiveContexts,
  changeActiveContexts,
  clearAllFlashContexts,
  onlyGenericFlashMessages,
  initFlashMessages,
  removeAllFlashMessages,
} = createActions(
  {
    REMOVE_FLASH_MESSAGE: (path: string[], id?: string) => ({ path, id }),
    REMOVE_BLINK_FLASH_MESSAGE: (path: string[], id?: string) => ({ path, id }),
    REMOVE_FLASH_MESSAGES_CONTEXTS: (path: string[], contexts: string[]) => ({ path, contexts }),
    REMOVE_FLASH_MESSAGES_CONTEXTS_ERRORS: (path: string[], contexts: string[]) => ({ path, contexts }),
    REMOVE_FLASH_LOCATIONS: (locations: string[]) => ({ locations }),
    REMOVE_FLASH_CONTEXTS: (path: string[], contexts: string[]) => ({ path, contexts }),
    REMOVE_ACTIVE_CONTEXTS: (contexts: string[]) => ({ contexts }),
    ADD_ACTIVE_CONTEXTS: (contexts: string[]) => ({ contexts }),
    REPLACE_ACTIVE_CONTEXTS: (searchContext: string[], newcontexts: string[]) => ({ searchContext, newcontexts }),
    CHANGE_ACTIVE_CONTEXTS: (contexts: string[]) => ({ contexts }),
  },
  'CLEAR_ALL_FLASH_CONTEXTS',
  'ONLY_GENERIC_FLASH_MESSAGES',
  'INIT_FLASH_MESSAGES',
  'REMOVE_ALL_FLASH_MESSAGES'
);

// Actions below will not be exported
const {
  // tslint:disable-next-line:variable-name
  addFlashMessages: _addFlashMessages,
} = createActions({
  ADD_FLASH_MESSAGES: (message: IntlMessagesError[] | string[], options?: BaseFlashMessageOptionsStore, isLoggedIn?: boolean) =>
    isLoggedIn === undefined ? { message, options } : { message, options, isLoggedIn },
});

export const addFlashMessages =
  (message: any, options?: any): AppThunk =>
  (dispatch, getState) => {
    const state = getState();
    const isLoggedIn = getIsLoggedInSelector(state);
    dispatch(_addFlashMessages(message, options, isLoggedIn));
  };

export const addFlashMessagePromise =
  (messages: any, flashContext: any) =>
  async (dispatch: any): Promise<void> =>
    new Promise(async (resolve, _) => {
      dispatch(addFlashMessages(messages, flashContext));
      resolve();
    });
